/* OH company reading layout: progressive enhancement of existing translated copy. */
(function () {
  'use strict';
  var ids = ['710374261081', '710363283801'];
  function init() {
    if (!ids.includes(document.body.dataset.ohPageId)) return;
    var root = document.querySelector('main .oh-help');
    if (!root || root.dataset.ohCompanyReady) return;
    var hero = root.querySelector(':scope > .oh-help-hero');
    var help = root.querySelector(':scope > .oh-help-nav');
    var headings = Array.from(root.querySelectorAll(':scope > h2'));
    if (!hero || headings.length < 2) return;
    var lang = (document.documentElement.lang || 'es').split('-')[0];
    var labels = {
      es: ['En esta página', 'Más ayuda'], en: ['On this page', 'More help'],
      fr: ['Sur cette page', 'Besoin d’aide ?'], de: ['Auf dieser Seite', 'Weitere Hilfe'],
      ru: ['На этой странице', 'Дополнительная помощь'], zh: ['本页目录', '更多帮助']
    }[lang] || ['On this page', 'More help'];
    var frame = document.createElement('div'); frame.className = 'oh-company-layout';
    var aside = document.createElement('aside'); aside.className = 'oh-company-index';
    var details = document.createElement('details');
    var summary = document.createElement('summary'); summary.textContent = labels[0];
    var nav = document.createElement('nav'); nav.setAttribute('aria-label', labels[0]);
    var list = document.createElement('ol');
    headings.forEach(function (heading, i) {
      if (!heading.id) heading.id = 'oh-company-chapter-' + (i + 1);
      heading.tabIndex = -1;
      var li = document.createElement('li');
      var link = document.createElement('a'); link.href = '#' + heading.id;
      var number = document.createElement('span'); number.setAttribute('aria-hidden', 'true'); number.textContent = String(i + 1).padStart(2, '0');
      var text = document.createElement('span'); text.textContent = heading.textContent.trim();
      link.append(number, text); li.append(link); list.append(li);
    });
    nav.append(list); details.append(summary, nav); aside.append(details);
    var article = document.createElement('article'); article.className = 'oh-company-article';
    Array.from(root.childNodes).forEach(function (child) {
      if (child === hero || child === help) return;
      if (child.nodeType === 3 && child.textContent.trim()) {
        var paragraph = document.createElement('p');
        paragraph.append(child); article.append(paragraph);
      } else article.append(child);
    });
    if (help) {
      var more = document.createElement('details'); more.className = 'oh-company-more';
      var moreSummary = document.createElement('summary'); moreSummary.textContent = labels[1];
      more.append(moreSummary, help); article.append(more);
    }
    frame.append(aside, article); root.append(frame);
    root.classList.add('oh-company'); root.dataset.ohCompanyReady = '1';
    var wide = window.matchMedia('(min-width: 1000px)');
    function setMode() { details.open = wide.matches; }
    setMode(); wide.addEventListener('change', setMode);
    nav.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault(); event.stopPropagation();
      if (!wide.matches) details.open = false;
      target.focus({preventScroll: true});
      history.replaceState(null, '', link.hash);
      var header = document.querySelector('.shopify-section--header');
      var inset = Math.max(0, header ? header.getBoundingClientRect().bottom : 0) + 24;
      window.scrollTo({top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - inset), behavior: 'instant'});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
